export default {
    TOTAL_TASKS: "Всего задач",
    COMPLETED: "Готово",
    FAILED: "С ошибкой",
    IN_PROGRESS: "Выполняется",
    PENDING: "Ожидает выполнения",
    CANCELED: "Остановлено",
    TASK_STATISTICS: "Статистика по задачам",
    SOURCE_STATISTICS: "Статистика по источникам"
};
